<template>
    <v-app>
        <loading :loading="!appLoadedOnce || loading"></loading>
        <force-premium v-if="appLoadedOnce" />
        <force-update v-if="appLoadedOnce" />
        
        <template v-if="appLoadedOnce">
            <app-menu v-model="openMenu"/>

            <navbar :height="navbarHeight" @menu="openMenu = !openMenu"/>
            

            <!-- confirm email msg -->
            <div v-if="innerApp && !confirmed" class="fixed-top-bar d-flex align-center justify-space-between justify-md-center pa-0 white--text orange" :style="`top: ${navbarHeight}px`">
                <div class="px-3">لم يتم تأكيد البريد الإلكتروني</div>
                <v-btn text large tile color="grey darken-3" class="light--text" @click.stop="openConfirmPage">
                    <span class="white--text">تأكيد</span>
                </v-btn>
            </div>
            
            <!-- full screen overlay - app is in maintainance -->
            <app-down :show="appIsDown" /> 

            <v-main v-if="appLoadedOnce && !appIsDown" class="main-container" :class="{'pc': pcOnly, 'white': $route.meta.whiteBackground || !isAuthed}" :style="'padding-top: ' + navbarHeight">
                <transition :name="transitionName" mode="out-in">
                    <router-view>
                        <!-- to add footer, just put <slot name="footer"> in view and set route meta.footer to true then footer will be auto inserted & transition will be auto changed   -->
                        <e-footer slot="footer" :fixed="!$route.meta.footer.notFixed" v-if="$route.meta.footer && $route.meta.footer.show" />
                    </router-view>
                </transition> 
            </v-main>
            
            <bottom-navigation v-if="capRunning" />

            <!-- footer -->
            <!-- <e-footer light v-if="appLoadedOnce && showFooter" /> -->
        </template>

        <app-msg :navbar-height="navbarHeight" />
    </v-app>
</template>

<script>
import AppDown from "./components/default/dialogs/app-down";
import AppMsg from "./components/default/app-msg";
import Loading from "./components/default/loading";

import GlobalComputed from './helpers/global-computed'
import GlobalMethods from './helpers/global-methods'

import Navbar from './components/main/navbar/navbar'
import AppMenu from './components/main/app-menu'
import EFooter from './components/main/e-footer'
 
import Echo from "laravel-echo"

import AppAPI from '@/app-api'
import ForceUpdate from "./components/default/dialogs/force-update";
import ForcePremium from "./components/default/dialogs/force-premium";

import BottomNavigation from './components/main/bottom-navigation'

export default {
    name: "App",
    
    components: {
        AppDown,
        Loading,
        EFooter,
        AppMsg,
        Navbar,
        AppMenu,
        BottomNavigation,
        ForceUpdate,
        ForcePremium
    },

    data: () => ({
        openMenu: false,
        navbarHeight: 65,
        transitionName: 'fade-up',
    }),
    computed: {
        appIsDown(){
            return this.appData && this.appData.appIsDown;
        },
        showFooter(){
            return this.$route.meta.footer;
        },
        innerApp(){
            return this.isAuthed && this.$route.name !== 'confirm';
        },
        confirmed(){
            if (!this.user || !this.appData.email_verification){
                return true;
            }
            return !!this.user.email_verified_at;
        },
        loading(){
            return this.$store.state.globalModule.loading;
        },
        ...GlobalComputed
    },
    watch: {
        $route(to, from){
            // force email verification
            this.forceEmailConfirm(to.name);
            this.transitionName = 'fade-up';
            
            if (to.meta.footer){
                // to fix footer bug with transition
                this.transitionName = 'fade';
            }
        },
        isAuthed(authed){
            if (!authed){
                this.$router.push({name: 'login'});
            }else{
                window.setTimeout(()=>{
                    this.connectToWebsockets();
                }, 1000);
            }
        },
    },
    methods: {
        openConfirmPage(){
            this.$router.push({name: 'confirm'});
        },
        forceEmailConfirm(route=null){
            if (!route){
                route = this.$route.name;
            }
            const force = process.env.VUE_APP_FORCE_CONFIRMATION;
            if (force){
                if (!this.confirmed){
                    if (route !== 'confirm'){
                        this.openConfirmPage();
                    }
                }
            }
        },
        afterAuthActions(){
            this.forceEmailConfirm();
            this.connectToWebsockets();
        },
        initApp(){
            const self = this;
            // window.console.log('App Init');
            // check token is valid or not
            this.$store.dispatch('checkAuth').then(response=>{
                // then set loaded to true
                window.setTimeout(()=>{
                    self.$store.dispatch('appLoaded'); // set app loaded status
                }, 250);

                if (response.authed){
                    self.afterAuthActions();
                }
                if (response.redirect){
                    self.$router.push({name: response.redirect});
                }
            }).catch(error=>{
                this.checkErrorStatus(error);
                this.showMsg('(2) تعذر التحقق من بياناتك، أعد فتح التطبيق');
                // this.snackMsg = {show: true, text: "حدثت مشكلة أثناء تحميل بياناتك"};
            });

        },
        connectToWebsockets(){
            let WsConfig = Object.assign({}, this.appData.WsConfig);
            if (WsConfig && !this.websocketsConnected){
                const token = window.localStorage.getItem('tK'),
                    apiUrl = window.apiUrl;
                
                let authUrl = WsConfig.authEndpoint;
                // change auth endpoint
                WsConfig.authEndpoint = `${authUrl}?api_token=${token}`;

                window.Echo = new Echo(WsConfig);
    

                this.websocketsConnected = true;
    
                // listen to inbox updates
                // window.Echo.private(`User.${this.user.id}.Inbox`)
                // .listen('InboxRoomUpdated', (response) => {
                //     this.$store.commit('UPDATE_ROOM', response.data.data);
                // });
            }
        },
        checkErrorStatus(error){
            if (error && error.response && error.response.status){
                // if unauthorized (maybe logout or token changed)
                if (error.response.status === 401){
                    this.logout();
                }
            }
        },
        ...GlobalMethods,
    },
    created(){
        if (this.capRunning){
            AppAPI.init(this);
            const primary = process.env.VUE_APP_STATUS_BAR_PRIMARY_COLOR === true || process.env.VUE_APP_STATUS_BAR_PRIMARY_COLOR === 'true';
            AppAPI.changeStatusbar(false, primary);
        }
    },
    mounted(){
        
        // first load app global data / settings (admin app data)
        this.$store.dispatch('loadAppData').then(()=>{
            // if nor running, init app now
            // we are on browser/web app!
            this.initApp();
            
        }).catch(e=>{
            const statusCode = (e && e.response && e.response.status) ? e.response.status : null;
            this.showMsg('تعذر الإتصال بالخادم، حاول لاحقاً' + (statusCode ? ` [${statusCode}]` : ''));
        })
    }
};
</script>

<style lang="scss">
@import 'scss/main';
.main-container{
    background-color: #fafafa;
}
</style>